var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['cl-checkbox', { 'cl-checkbox-active': _vm.checked }],on:{"click":_vm.handleClick}},[_c('img',{staticClass:"check-icon",attrs:{"src":require('./icon/check.svg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }